var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('nav',{staticClass:"voyage-section-nav",attrs:{"aria-label":"Voyage sections"}},_vm._l((_vm.sections),function(section){return _c('button',{key:section.id,staticClass:"voyage-section-pill",attrs:{"type":"button"},on:{"click":function($event){return _vm.scrollTo(section.id)}}},[_vm._v(_vm._s(section.label))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }